import * as React from 'react';
import { ArticleParagraph1, Button } from '@cian/ui-kit';

import * as styles from './NewbuildingBlackFridayBanner.css';

interface INewbuildingBlackFridayBannerProps {
  url: string;
  onClick: () => void;
}

export function NewbuildingBlackFridayBanner({ url, onClick }: INewbuildingBlackFridayBannerProps) {
  return (
    <a
      className={styles['container']}
      data-testid="BlackFridayBanner"
      href={url}
      onClick={onClick}
      rel="noreferrer"
      target="_blank"
    >
      <h2 className={styles['title']} role="presentation">
        Чёрная пятница 16-24 ноября
      </h2>
      <div className={styles['description']}>
        <ArticleParagraph1 color="white_100">
          Эксклюзивные скидки на новостройки от застройщиков и банков
        </ArticleParagraph1>
      </div>
      <div className={styles['button-wrapper']}>
        <Button theme="fill_white_primary" size="M">
          Подробнее
        </Button>
      </div>
    </a>
  );
}
